import type { GridInitialState } from '@mui/x-data-grid-pro'
import { defaultUserSearchPreferences } from './defaults'
import type {
  UserSearchPreferences,
  UserSearchPreferencesQueryResult as UserSearchPreferencesQuery,
} from './types'

export const mapServerToLocal = (
  queryResult: UserSearchPreferencesQuery,
): UserSearchPreferences => {
  if (!queryResult) {
    console.log('No user preferences from server, using frontend defaults')
    return defaultUserSearchPreferences
  }
  const settings = Object.assign({}, defaultUserSearchPreferences, {
    display: queryResult.listView ? 'grid' : 'card',
    displayWidth: queryResult.expandedWidth ? 'wide' : 'narrow',
    columnOrder: queryResult.columnOrder,
    columnsToDisplay: queryResult.columnsToDisplay,
    resultsPerPage: queryResult.resultsPerPage,
  }) as UserSearchPreferences

  return settings
}

export const mapLocalToServer = (
  prefs: UserSearchPreferences,
): UserSearchPreferencesQuery => ({
  listView: prefs.display === 'grid',
  expandedWidth: prefs.displayWidth === 'wide',
  resultsPerPage: prefs.resultsPerPage,
  columnOrder: prefs.columnOrder,
  columnsToDisplay: prefs.columnsToDisplay,
})

export const mapLocalToDataGrid = (
  searchPreferences: UserSearchPreferences,
): GridInitialState => ({
  pagination: {
    paginationModel: {
      page: 0,
      pageSize: searchPreferences.resultsPerPage ?? 25,
    },
  },
  columns: {
    orderedFields: searchPreferences.columnOrder,
    columnVisibilityModel: searchPreferences.columnsToDisplay,
  },
  pinnedColumns: {
    left: ['__check__', 'actions'],
  },
})
